import React from 'react'

const FeatureOne = () => {
    return (
        <section className='bg-dark'>
            <div className="feature-area-4 space-bottom">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7">
                            <div className="title-area text-center">
                                <span className="sub-title text-white">
                                    <img src="assets/img/icon/title_left.svg" alt="shape" />
                                    Our Features
                                </span>
                                <h2 className="sec-title style2 text-white">
                                    Your Business Goals with the Confidence
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="feature-wrap4">
                        <div className="feature-bg-line">
                            <img src="assets/img/feature/feature_line.png" alt="img" />
                        </div>
                        <div className="row gy-80 justify-content-center justify-content-lg-between align-items-center">
                            <div className="col-lg-5 order-lg-2">
                                <div className="feature-thumb4-1">
                                    <img src="assets/img/feature/feature-4-1.png" alt="img" />
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 order-lg-1">
                                <div className="feature-content">
                                    <h4 className="feature-content-title text-white mb-20">
                                        Achieve Your a of Business{" "}
                                    </h4>
                                    <p className="feature-content-text mb-30 text-white">
                                        We have been operating for over a decade, providing top-notch
                                        services to our clients and building a strong track record in the
                                        industry.We have been
                                    </p>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="checklist style-white2">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" /> Mistakes To Avoid
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" /> Your Startup
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="checklist style-white2">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" /> Mistakes To Avoid
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" /> Your Startup
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 order-3">
                                <div className="feature-thumb4-1">
                                    <img src="assets/img/feature/feature-4-2.png" alt="img" />
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 order-4">
                                <div className="feature-content">
                                    <h4 className="feature-content-title mb-20 text-white">
                                        Marketing and Branding business Consultants
                                    </h4>
                                    <p className="feature-content-text mb-30 text-white">
                                        We have been operating for over a decade, providing top-notch
                                        services to our clients and building a strong
                                    </p>
                                    <div className="row gy-4">
                                        <div className="col-lg-6">
                                            <h5 className="feature-content-subtitle text-white">
                                                Operational Excellence
                                            </h5>
                                            <p className="feature-content-text text-white">
                                                Et purus duis sollic itudin sed dignis{" "}
                                            </p>
                                        </div>
                                        <div className="col-lg-6">
                                            <h5 className="feature-content-subtitle text-white">
                                                Transform Strate
                                            </h5>
                                            <p className="feature-content-text text-white">
                                                Et purus duis sollic itudin sed dignis{" "}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


    )
}

export default FeatureOne